import React, { Fragment } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Hero6 from '../../components/hero6/hero6'
import PageTitle from '../../components/pagetitle/PageTitle'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation'
import About from '../../components/about/about'
import AboutMission from '../../components/about/AboutMission'
// import ProjectSection from '../../components/ProjectSection/ProjectSection'
import ServiceSection from '../../components/ServiceSection/ServiceSection'
// import FunFact from '../../components/FunFact/FunFact'
// import PartnerSection from '../../components/PartnerSection/PartnerSection'
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Logo from '../../images/logo-2.svg'
// import PricingSection from '../../components/PricingSection/PricingSection'
// import CtaSection from '../../components/CtaSection/CtaSection'

const AboutPage = () => {
  return (
    <Fragment>
      <Navbar
        hclass={'wpo-site-header wpo-header-style'}
        Logo={Logo}
        col1={'col-lg-3 col-md-2 col-2 d-lg-none dl-block'}
        col2={'col-lg-5 col-md-6 col-10'}
        col3={'col-lg-5 col-md-1 col-1'}
        col4={'col-lg-2 col-md-2 col-2'}
      />
      <Hero6 />

      <PageTitle
        pageTitle={''}
        pagesub={'About Us'}
      />
      <ScrollTextAnimation />
      <About hclass={'wpo-about-section section-padding pb-0'} />
      <AboutMission hclass={'wpo-about-section-mission section-padding pb-0'} />
      {/* <ServiceSection hclass={'wpo-service-section'} /> */}
      {/* <CtaSection hclass={'wpo-funfact-section'} /> */}
      {/* <PartnerSection hclass={'wpo-partners-section fade_bottom'} /> */}
      <Footer />
      <Scrollbar />
    </Fragment>
  )
}
export default AboutPage
